import { RegisteredComponent } from '@builder.io/sdk-react';
import { BuilderIoButton, BuilderIoButtonInputs } from './BuilderIoButton';
import { BuilderIoCollapse, BuilderIoCollapseInputs } from './BuilderIoCollapse/BuilderIoCollapse';
import { BuilderIoImage, BuilderIoImageInputs } from './BuilderIoImage';
import { BuilderIoSlider, BuilderIoSliderInputs } from './BuilderIoSlider/BuilderIoSlider';
import { BuilderIoTab, BuilderIoTabInputs } from './BuilderIoTab/BuilderIoTab';
import { BuilderIoTabs, BuilderIoTabsInputs } from './BuilderIoTabs/BuilderIoTabs';

export const customComponents: RegisteredComponent[] = [
  {
    name: 'Adaptive Image',
    component: BuilderIoImage,
    inputs: BuilderIoImageInputs,
  },
  {
    name: 'Button',
    component: BuilderIoButton,
    inputs: BuilderIoButtonInputs,
  },
  {
    name: 'Collapse',
    component: BuilderIoCollapse,
    inputs: BuilderIoCollapseInputs,
  },
  {
    name: 'Slider',
    component: BuilderIoSlider,
    inputs: BuilderIoSliderInputs,
    canHaveChildren: true,
  },
  {
    name: 'Tabs',
    component: BuilderIoTabs,
    inputs: BuilderIoTabsInputs,
    canHaveChildren: true,
  },
  {
    name: 'Tab Content',
    component: BuilderIoTab,
    inputs: BuilderIoTabInputs,
    canHaveChildren: true,
  },
];
